import { component$, Slot } from "@builder.io/qwik";
import { FeatureCheck } from "./ui/feature-check";

export interface FeatureListProps {
  features: { feature: string }[];
}

export const FeatureList = component$<FeatureListProps>(({ features }) => {
  return (
    <ul class="block flex flex-col gap-2">
      {features.map((f, i) => (
        <li key={i} class="flex items-center gap-2">
          <FeatureCheck />
          {f.feature}
          <Slot />
        </li>
      ))}
    </ul>
  );
});
